import { useQuery } from '@apollo/client';
import { useState, useEffect, useCallback } from 'react';
import { IOption } from '../../../types/common';
import Typeahead from './typeahead';

import { IAllRootOrgsResponse, IOrgLight } from '../../../types/org';
import { GET_ALL_ROOT_ORGS } from '../../../graphql/org-gql';

type TopOrganizationTypeaheadProps = {
    initOrgId?:number
    orgSelectHandle: (org: IOrgLight | undefined) => void;
    validate:(error:string)=>void;
    elementId:string;
    limit?:number;
}

const TopOrganizationTypeahead = (props: TopOrganizationTypeaheadProps) => {
    const { orgSelectHandle,validate,elementId,limit } = props  
    const [dropdownOptions,setDropdownOptions] = useState<IOption[]>([]);
    const [suggestions, setSuggestions] = useState<IOption[]>([]);
    const [selectedOrg, setSelectedOrg] = useState<IOption>()
    const { data,loading } = useQuery<IAllRootOrgsResponse>(GET_ALL_ROOT_ORGS)

    const [error,setError] = useState<string>('');

    useEffect(()=>{
        if(data?.allRootOrgs){
            let firstOpt : IOption = {id:0,label:'All'}
            setSelectedOrg(firstOpt)
            const convertedOptions: IOption[] = [firstOpt].concat( 
                data.allRootOrgs.map((org: IOrgLight) => ({
                    id: org.id,
                    label: org.orgName,
                })));
              setDropdownOptions(convertedOptions);
        } 
    
      },[data])

    useEffect(() => {
        validate(error);
    }, [error])

    const filteredSuggestions = (query:string) => dropdownOptions.filter(opt =>
        opt.label.toLowerCase().startsWith(query.toLowerCase())
      );

    const queryOrg = (str: string) => {
        //console.log("str:",str)
        const suggestions = filteredSuggestions(str)
        setSuggestions(suggestions)
        if ((suggestions && suggestions.length > 0))
            setError('')
        else
            setError('No Organization found.')

    }

    const selectOrgHandle = useCallback((opt: IOption) => {
        setSelectedOrg(opt)
        let org = data?.allRootOrgs.find(e => e.id === opt?.id)
        orgSelectHandle(org ? org : undefined)
        setError('')
    }, [data])

    const onBlur = () =>{
        setError('');
    }

    const onClear = () => {
        
    }

    return (
        <div >
            <Typeahead
                placeHolder='Start entering a organization and a list will appear'
                options={suggestions}
                dropdownOptions = {dropdownOptions}
                value={selectedOrg}
                loading={loading}
                query={queryOrg}
                onSelected={selectOrgHandle}
                id={elementId}
                onBlur={onBlur}
                error = {error}
                onClear={onClear}
            />
        </div>
    )
}

export default TopOrganizationTypeahead
